const inspectionProfile = {
  buttons: {
    backbtn: "Go Back",
    submit: "Submit",
    upload: "Upload",
    addFile: "Add File"
  },
  newInspection: "Create New Inspection",
  details: "Inspection Details",
  equipmentTag: "Asset Tag",
  client: "Customer",
  equipType: "Asset Type",
  company: "Company",
  createby: "Create By",
  date: "Date Created",
  coupled: "In Board",
  free: "Out Board",
  preasureBar: "Pressure (BAR)",
  preasurePsi: "Pressure (PSI)",
  stuffingBox: "Stuffing Box",
  temperature: "Temperature",
  pressure: "Pressure",
  celsius: "Temperature (Celsius)",
  fahrenheit: "Temperature (Fahrenheit)",
  coolingWaterIn: "Cooling Water In",
  coolingWaterOut: "Cooling Water Out",
  pumpHousing: "Pump Housing",
  oilIn: "Oil In",
  ollOut: "Oil Out",
  level: "Level",
  levelmm: "Level (mm)",
  levelL: "Level (l)",
  refilling: "Refilling System",
  system: "System",
  instrument: "Instrument Air",
  tank: "Tank",
  cw: "Cooling Water",
  cin: "In Board In",
  cout: "In Board Out",
  fin: "Out Board In",
  fout: "Out Board Out",
  motor: "Motor",
  barrier: "Barrier Flow",
  barrierFlowLmin: "Barrier Flow (L/min)",
  Comment: "Comment",
  barrierFlowGalmin: "Barrier Flow (G/min)",
  delete: "Delete Inspection",
  inspectionSummary: "Inspection Summary",
  PerfomedBy: "Perfomed By",
  createdBy: "Created By",
  generalStatus: "General Status",
  alarmZone: "Alarm Zone",
  warningZone: "Warning Zone",
  smoothZone: "Smooth Zone",
  update: "Update",
  addMultimedia: " Add Multimedia",
  multimediaDetails: "Details",
  multimediaHint:
    "Add details about the media file you want to upload for the inspection profile",
  multimediaMessage: "There is no media file for this inspection yet",
  summary: "Summary",
  variables: "Variables",
  multimedia: "Multimedia",
  inspectionMultimedia: "Inspection Multimedia",
  fileInput: "File Input",
  status: {
    smooth: "Smooth",
    warning: "Warning",
    alarm: "Alarm"
  }
};
export default inspectionProfile;
